module.exports = "<toaster-container [toasterconfig]=\"config\"></toaster-container>\n<router-outlet></router-outlet>\n"